import React from 'react'
import classNames from 'classnames'

const HistoryList = props => {
  const items = props.items
  const HistoryList = items.map((item, i) => (
    <li
      className={classNames({
        'history-item': true,
        [item.className]: item.className
      })}
      key={i}
    >
      <span className='amount'>{item.amount}</span>
      <span className='time'>
        <p className='time-item'>{item.time}</p>
        <p className='time-item'>{item.date}</p>
      </span>
    </li>
  ))
  return <ul className='history-list'>{HistoryList}</ul>
}

export default HistoryList



// WEBPACK FOOTER //
// ./src/ui/lists/history-list.js